/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetthumbpicturesResponseItems,
    GetthumbpicturesResponseItemsFromJSON,
    GetthumbpicturesResponseItemsFromJSONTyped,
    GetthumbpicturesResponseItemsToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetthumbpicturesResponse
 */
export interface GetthumbpicturesResponse {
    /**
     * 
     * @type {Array<GetthumbpicturesResponseItems>}
     * @memberof GetthumbpicturesResponse
     */
    items?: Array<GetthumbpicturesResponseItems>;
}

export function GetthumbpicturesResponseFromJSON(json: any): GetthumbpicturesResponse {
    return GetthumbpicturesResponseFromJSONTyped(json, false);
}

export function GetthumbpicturesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetthumbpicturesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(GetthumbpicturesResponseItemsFromJSON)),
    };
}

export function GetthumbpicturesResponseToJSON(value?: GetthumbpicturesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : ((value.items as Array<any>).map(GetthumbpicturesResponseItemsToJSON)),
    };
}


